// Measured on authenticated coach-dev dashboard and CRM on 2026-11-03.
export const adminFont = '"DM Sans",-apple-system,system-ui,sans-serif';
export const adminType = {
  pageTitle: { fontFamily: adminFont, fontSize: 30, fontWeight: 700, lineHeight: 1.1 },
  description: { fontFamily: adminFont, fontSize: 15, fontWeight: 400, lineHeight: 1.5 },
  body: { fontFamily: adminFont, fontSize: 14, fontWeight: 400, lineHeight: 1.5 },
  secondary: { fontFamily: adminFont, fontSize: 13, fontWeight: 400, lineHeight: 1.5 },
  caption: { fontFamily: adminFont, fontSize: 12, fontWeight: 400, lineHeight: 1.5 },
  dialogTitle: { fontFamily: adminFont, fontSize: 20, fontWeight: 400, lineHeight: 1.3 },
};
export const adminTypeVariables = {
  '--admin-font': adminFont,
  '--admin-heading-font': adminFont,
  '--admin-page-title-size': '30px',
  '--admin-page-title-weight': 700,
  '--admin-page-title-line': 1.1,
  '--admin-description-size': '15px',
  '--admin-description-line': 1.5,
  '--admin-dialog-title-size': '20px',
  '--admin-dialog-title-weight': 400,
  '--admin-dialog-title-line': 1.3,
};
